@if (mostrarShell()) {
  <!-- ── El shell YA CABLEADO ───────────────────────────────────────────────
       `[marca]` es lo único propio de esta aplicación. Los módulos, el usuario
       de la barra, las tarjetas de acceso, el acceso vigente, la salida y el
       cambio de aplicación los resuelve `<intelishs-shell-sesion>` desde
       `SesionService`.

       `[modulos]` SÍ se pasa aquí, y es el caso atípico que justifica que ese
       input exista: el rol de este portal tiene CERO módulos otorgados porque
       su acceso es derivado —superadministrador—, así que su menú sale de un
       catálogo local. Cualquier otro front lo omite. -->
  <intelishs-shell-sesion [marca]="marca" [modulos]="navegacion.modulos()">
    <router-outlet />
  </intelishs-shell-sesion>

  <!-- ── Volver al inicio ──────────────────────────────────────────────────
       ⚠️ VA DENTRO DEL `@if`, y esto NO es cosmetico: es la correccion de un
       fallo silencioso que el boilerplate arrastra (esta igual en
       FLicitacionesSchema, comentario incluido).

       `target` no es opcional aqui: el default vigila el scroll del DOCUMENTO, y
       este shell tiene `overflow: hidden` con `height: 100dvh`, asi que el
       documento no scrollea nunca.

       Pero el selector solo no basta. `BackToTop` resuelve su contenedor UNA vez
       en `ngOnInit` —`querySelector(target) ?? documentElement`— y suscribe el
       evento `scroll` a lo que encuentre ahi. Montado FUERA del `@if`, en un
       arranque sin sesion `.shell__contenido` todavia no existe: cae al
       documento, se suscribe a `window`, y como el documento nunca scrollea el
       evento no vuelve a dispararse. Resultado: tras iniciar sesion el boton no
       aparece JAMAS hasta recargar la pagina, sin un solo error en consola.

       Va DESPUES del shell y no dentro: Angular crea los nodos en orden, asi
       que cuando este se monta el `<main>` del shell ya esta en el DOM.

       REPORTADO: la correccion pertenece al boilerplate de `new-sinay-frontend`,
       y lo ideal seria que `BackToTop` aceptara un `ElementRef` o reintentara
       resolver el target, para que un montaje prematuro no lo deje inerte. -->
  <intelishs-back-to-top target=".shell__contenido" />
} @else {
  <!-- Sin sesion no hay marco que dibujar. `sesionGuard` ya mando al login
       central; esto solo evita pintar un shell a medias mientras se sale. -->
  <router-outlet />
}

<!-- Visor global de archivos: UNICA instancia en toda la app (se invoca via FileViewerService) -->
<intelishs-file-viewer />

<!-- ⚠️ Aqui estaba `<intelishs-overlay-carga />`. Lo monta ahora
     `<intelishs-shell-sesion>`: el servicio del velo es unico, asi que dejarlo
     tambien aqui pintaria DOS velos superpuestos. -->
